import { type IconName } from '@sg/garnish';

/**
 * Maps the credit card type to its corresponding icon.
 */
export const getCreditCardIcon = (type: string): IconName => {
  switch (type) {
    case 'VISA': {
      return 'IconCcVisa';
    }

    case 'MASTER_CARD': {
      return 'IconCcMasterCard';
    }

    case 'DISCOVER': {
      return 'IconCcDiscover';
    }

    case 'AMEX': {
      return 'IconCcAmex';
    }

    case 'AMERICAN_EXPRESS': {
      return 'IconCcAmex';
    }

    default: {
      return 'IconCreditCard';
    }
  }
};
